import { TReduxActions } from '../../types/redux';
import { ELocationActionTypes } from '../../constants/actionTypes/location';
import { ILocation } from '../../types/location';

export type TLocationState = ILocation | null;

const initialState: TLocationState = null;

export const locationReducer = (state: TLocationState = initialState, action: TReduxActions) => {
  switch (action.type) {
    case ELocationActionTypes.SET_LOCATION:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
